import { NSAHomePage, NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { StorageLayout } from "../StorageLayout";
import { StorageRouterProps } from "../StorageRouterProps";

interface HomePageProps extends NSARouterMakerResult, StorageRouterProps { }

class HomePage extends Component<HomePageProps>
{
    override render()
    {
        return (
            <StorageLayout {...this.props}>
                <NSAHomePage {...this.props} />
            </StorageLayout>
        );
    }
}

export default HomePage;